import * as types from './../constants/actionTypes';

const initialState = {
    showHtmlForm: false,
    htmlFormSimple: ''
};

 const CreditCardReduser = (state = initialState, action) => {
    switch (action.type){

        case types.UPDATE_BALANCE_TOPUPEWALLET_SUCCESSFUL:
            return {
                ...state,
                htmlForm: action.htmlForm,
                xid: action.xid,
                showHtmlForm: true
            };

        case types.SAVE_HTML_FORM:
              return{
                ...state,
                htmlFormSimple: action.htmlFormSimple
              };

        case types.UPDATE_BALANCE_TOPUPEWALLET_FAILED:
            return {
                ...state,
                showHtmlForm: false
            };

        case types.CLOSE_HTML_FORM:
            return  {
                ...state,
                showHtmlForm: false,
               isLoadingPayment: true
            };
        case types.SET_PAYMENT_STATUS:
            return {
                ...state,
                paymentStatus: action.paymentStatus,
                paymentDescription: action.paymentDescription,
                isLoadingPayment: false
            };

        case types.SET_PAYMENT_STATUS_PROGRESS:
            return {
                ...state,
                isLoadingPayment: true
            };

        default:
            return state;
    }

};

export default CreditCardReduser;



// WEBPACK FOOTER //
// ./src/reducers/CreditCardReducer.js